import Listings from "@realtorSitesClient/pages/Listings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/listings/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Listings />;
}
